import React from 'react'
import {useEffect, useState, Fragment} from 'react'
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles'
import {Stepper, Step, StepButton, StepLabel, Collapse, Table, TableBody, TableCell, 
    TableContainer, TableHead, TableRow, Grid, Paper, IconButton, Button, TextField,
    Box, Typography, Switch, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, Zoom, CircularProgress,
    Menu,
    MenuItem} from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import {authFetch, logout} from '../../auth';
import getPeriods from '../../const/yearPeriods';
import getMonths from '../../const/monthPeriods';
import getAbbMonths from '../../const/abbMonthsPeriods';
import validateInput from '../../const/validation';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import AddIcon from '@material-ui/icons/Add';
import TimelineIcon from '@material-ui/icons/Timeline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import BuildIcon from '@material-ui/icons/Build';
import Plot from 'react-plotly.js';
import * as localeDictionary from 'plotly.js/lib/locales/es.js'

import { set } from 'date-fns';
import { cy } from 'date-fns/locale';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      padding: theme.spacing(2),
      color: theme.palette.primary.main
    },
    hoverBackground:{
      background: theme.palette.action.hover
    },
    componentTitle: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.secondary.main,
      padding: theme.spacing(1),
      borderRadius: 10,
      marginBottom: theme.spacing(1),
      marginTop: '20%'
    },
    componentTitleNoMargin: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.secondary.main,
      padding: theme.spacing(1),
      borderRadius: 10,
      marginBottom: theme.spacing(3),      
    },
    rlqMsg: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.secondary.main,
      padding: theme.spacing(1),
      borderRadius: 10,
      marginBottom: theme.spacing(1),
    },
    button: {
      marginRight: theme.spacing(1),
      paddingTop: 0
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    modalPaper: {
      padding: theme.spacing(3),
      marginTop: '10%'
    },
    stepper: {
        padding: theme.spacing(3)
    },
    stepText: {
        color: theme.palette.secondary.dark,
    },
    stepTextActive: {
        color: theme.palette.primary.main,
    }, 
    uploadButton : {
      fontSize: 14,
      [theme.breakpoints.down('xs')]: {
        fontSize: 8,
      },
    }
}));

const useRowStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
    hoverBackground:{
      background: theme.palette.action.hover
    },
}));

const StyledTableCell3StepInfo = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    padding: 3,
    paddingRight: 3,
  },
  body: {
    fontSize: 14,
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
    color: theme.palette.primary.dark,
    border: `2px solid ${theme.palette.primary.light}`,
    padding: 3,
  },
}))(TableCell);

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,      
      padding: 5
    },
    body: {
      fontSize: 14,
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
      },
      color: theme.palette.primary.dark,
      padding: 5
    },
  }))(TableCell);

const StyledTableCellSecondStep = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,     
      //width: "15%",
      padding: 5
    },
    body: {
      fontSize: 14,
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
    },
      color: theme.palette.primary.dark,
      padding: 5
    },
  }))(TableCell);

const StyledTableCellCollapse = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,      
      padding: 5
    },
    body: {
      fontSize: 14,
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
      },
      color: theme.palette.primary.dark
    },
  }))(TableCell);
  
const StyledTableRow = withStyles((theme) => ({
    root: {
      color: theme.palette.primary.main,
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

/* Validacion */

/*Data de las tablas*/
function getSteps() {
    return ['Verifique la información de los ciclos a procesar.', 'Suba los archivos correspondientes.', 'Compruebe la información procesada.'];
}

  
function ThirdStepRow(props) {
    const row  = props.row;
    const [open, setOpen] = useState(false);
    const classes = useRowStyles();
  
    return (
      <React.Fragment>
        <StyledTableRow className={classes.root}>
          <StyledTableCell>
            <IconButton aria-label="expand row"  size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </StyledTableCell>
          <StyledTableCell align="left">
            {row.code}
          </StyledTableCell>
          <StyledTableCell align="left">{props.cyclesUsers[row.code]}</StyledTableCell>
          <StyledTableCell align="left">{ String(props.billingDate.getMonth() + 1) + '/' + String(props.billingDate.getFullYear())}</StyledTableCell>          
        </StyledTableRow>
        <StyledTableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6} className={classes.hoverBackground}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div" color="primary">
                  Información asociada
                </Typography>
                <Grid container spacing={1} justify="center">
                  <Grid item xs={3}>
                    <Table  style={{tableLayout: 'fixed', fontSize: 14}}>
                      <TableHead>
                        <StyledTableRow>
                        {['Usuarios procesados'].map((label, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center" style={{fontSize: 14}}>{label}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>                                       
                        <StyledTableRow>
                        {[props.cycleConsumption[ 'u_'+row.code ]].map((value, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center"  style={{fontSize: 14}}>{value}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>                                                                                
                      </TableBody>
                    </Table>
                  </Grid>
                  <Grid item xs={6}>
                    <Table  style={{tableLayout: 'fixed', fontSize: 14}}>
                      <TableHead>
                        <StyledTableRow>
                        {['Usuarios faltantes'].map((label, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center" style={{fontSize: 14}}>{label}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>                                       
                        
                        { props.cycleConsumption[ 'not_found_'+row.code ] ?
                            props.cycleConsumption[ 'not_found_'+row.code ].map((value, idx) => (
                            <StyledTableRow key={idx}>
                            <StyledTableCell3StepInfo align="center"  style={{fontSize: 14}}>{value}</StyledTableCell3StepInfo>
                            </StyledTableRow> 
                          ))
                          :
                          <StyledTableRow>
                          <StyledTableCell3StepInfo align="center"  style={{fontSize: 14}}>{'-'}</StyledTableCell3StepInfo>
                          </StyledTableRow>
                        }
                                                                                                        
                      </TableBody>
                    </Table>
                  </Grid>
                  <Grid item xs={12}><Typography align="center" color="primary">Totales</Typography></Grid>
                  <Grid item xs={2}>
                    <Table style={{tableLayout: 'fixed', fontSize: 14}}>
                      <TableHead>
                        <StyledTableRow>
                        {['Energía activa'].map((label, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center" style={{fontSize: 14}}>{label}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>                                       
                        <StyledTableRow>
                        {[props.cycleConsumption[ 'total_active_'+row.code ]].map((value, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center"  style={{fontSize: 14}}>{value+ ' kWh'}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>                                                                                
                      </TableBody>
                    </Table>
                  </Grid>
                  <Grid item xs={2}>
                    <Table  style={{tableLayout: 'fixed', fontSize: 14}}>
                      <TableHead>
                        <StyledTableRow>
                        {['Energía inductiva'].map((label, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center" style={{fontSize: 14}}>{label}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>                                       
                        <StyledTableRow>
                        {[props.cycleConsumption[ 'total_inductive_'+row.code ]].map((value, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center"  style={{fontSize: 14}}>{value+ ' kVarh'}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>                                                                                
                      </TableBody>
                    </Table>
                  </Grid>
                  <Grid item xs={2}>
                    <Table  style={{tableLayout: 'fixed', fontSize: 14}}>
                      <TableHead>
                        <StyledTableRow>
                        {['Energía ind. penalizada'].map((label, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center" style={{fontSize: 14}}>{label}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>                                       
                        <StyledTableRow>
                        {[props.cycleConsumption[ 'total_inductive_pen_'+row.code ]].map((value, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center"  style={{fontSize: 14}}>{value+ ' kVarh'}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>                                                                                
                      </TableBody>
                    </Table>
                  </Grid>
                  <Grid item xs={2}>
                    <Table  style={{tableLayout: 'fixed', fontSize: 14}}>
                      <TableHead>
                        <StyledTableRow>
                        {['Energía capacitiva'].map((label, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center" style={{fontSize: 14}}>{label}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>                                       
                        <StyledTableRow>
                        {[props.cycleConsumption[ 'total_capacitive_'+row.code ]].map((value, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center"  style={{fontSize: 14}}>{value+ ' kVarh'}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>                                                                                
                      </TableBody>
                    </Table>
                  </Grid>
                  <Grid item xs={2}>
                    <Table  style={{tableLayout: 'fixed', fontSize: 14}}>
                      <TableHead>
                        <StyledTableRow>
                        {['Energía capacitiva penalizada'].map((label, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center" style={{fontSize: 14}}>{label}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>                                       
                        <StyledTableRow>
                        {[props.cycleConsumption[ 'total_capacitive_pen_'+row.code ]].map((value, idx) => (
                          <StyledTableCell3StepInfo key={idx} align="center"  style={{fontSize: 14}}>{value+ ' kVarh'}</StyledTableCell3StepInfo>
                        ))}
                        </StyledTableRow>                                                                                
                      </TableBody>
                    </Table>
                  </Grid>
                </Grid>
                
              </Box>
            </Collapse>
          </TableCell>
        </StyledTableRow>
      </React.Fragment>
    );
}

export default function InputVerification (props) {
  const classes  = useStyles();
  var actualYear = new Date().getFullYear()    
  let billingDate = props.billingDate        
  const [modificationDialog, setModificationDialog] = useState(false)
  const [modificationDesignation, setModificationDesignation] = useState([])
  const [uploadDialog, setUploadDialog] = useState(false)
  const [uploadMessage, setUploadMessage] = useState('')
  const [activeStep, setActiveStep] = useState(0);

  const [cycles, setCycles] = useState([])
  const [cyclesUsers, setCyclesUsers] = useState({})
  const [cycleConsumption, setCycleConsumption] = useState({})

  const [billingStatus, setBillingStatus] = useState({})  
  const [isLoading, setIsLoading] = useState(false)
  const [clickIndex, setClickIndex] = useState(-1)
  const [uploadMsg, setUploadMsg] = useState("")
  const steps = getSteps();

  const [selectedClient, setSelectedClient] = useState('')
  const [typicalCurveUploading, setTypicalCurveUploading] = useState(false)
  const [typicalCurveUploadMsg, setTypicalCurveUploadMsg] = useState("")

  const [userWithTypicalCurve, setUserWithTypicalCurve] = useState(false)
  const [openModal, setOpenModal] = useState(false);
  const [typicalCurveInfo, setTypicalCurveInfo] = useState({
    eje_x_dias: [],
    eje_y_totales_diarios: [],
    suma_total_mes: 0
  });

  const [typicalCurveLoading, setTypicalCurveLoading] = useState(false)
  const [typicalCurveLoadingMsg, setTypicalCurveLoadingMsg] = useState("")
  const [downloadingZipTypicalCurves, setDownloadingZipTypicalCurves] = useState(false)

  // Estados para modo mantenimiento (ceros programados en curva típica)
  const [maintenanceDialogOpen, setMaintenanceDialogOpen] = useState(false)
  const [currentCycleForMaintenance, setCurrentCycleForMaintenance] = useState(null)
  const [maintenanceConfig, setMaintenanceConfig] = useState({
    clientCode: '',
    startDateTime: '',
    endDateTime: ''
  })
  const [cycleMaintenanceRules, setCycleMaintenanceRules] = useState({})

  let theme = useTheme()

  const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  
  const handleStep = (step) => () => {
      setActiveStep(step);
  };

  const handleBack = () => {        
      if (activeStep > 0){
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      }
  };

  const handleModificationDialogClose = () => {
    setModificationDialog(false)
  }

  const handleUploadDialogClose = () => {
    setUploadDialog(false)
  }

  // A modificar acorde a agpe gd
  const handleUploadFile = (e, cycle, autogenerator)  => {            
    e.preventDefault()
    if (e.target.files.length > 0){                 
      setIsLoading(true)                     
      setUploadMsg("Subiendo archivo...")
      const formData = new FormData()
      let i = 0
      let file = {}
      let file_extension = e.target.files[0].name.split('.').pop()
      for (file of e.target.files){
          formData.append('file' + i, file)
          i = i + 1
      }
      let opts = {
          'filename': e.target.files[0].name,      
          'contentType': e.target.files[0].type,              
      }
      authFetch(
          "/api/get-gcs-signed-url?username="+props.username+
                          "&period="+String( billingDate.getMonth() + 1 )+                                                              
                          "&year="+ billingDate.getFullYear(),
          {
              method: 'post',                
              //body: formData,
              body: JSON.stringify(opts)
          }
      ).then(r => {
            if (r.status === 422){
              logout()
              return null
            }
            else{
              return r.json()
            }
          })
      .then(response => {
          if (response.url){   
              let gcs_signed_url = response.url
              fetch(
                  gcs_signed_url,               
                  {
                      method: 'put',            
                      body: e.target.files[0],
                      headers: {
                          'Content-Type': e.target.files[0].type
                      }
                  }
              ).then(r => {if (r.status === 200){ return true } else {return false}})
                  .then(response => {
                      if (response){
                        setUploadMsg("Procesando archivo...")
                        //alert('llamado a procesar')
                        let processOpts = {
                          ...opts,
                          maintenance_rules: cycleMaintenanceRules[cycle] || []
                        }
                        authFetch("/api/process-consumption-file?username="+props.username+
                                                  "&billing_period="+String( billingDate.getMonth() + 1 )+                                                                                                                                  
                                                  "&billing_year="+ billingDate.getFullYear() +                                                                                                                                              
                                                  "&cycle="+ cycle + 
                                                  "&autogenerator="+ autogenerator +
                                                  "&user_type="+ props.userType +
                                                  "&file_extension="+ file_extension
                                                  + "&version=" + props.tariffCalcVersion,
                          {
                            method: 'post',                
                            body: JSON.stringify(processOpts)
                          }
                        ).then(response => {
                          if (response.status !== 200){
                            setUploadDialog(true)
                            setIsLoading(false)
                            setUploadMessage('Error al subir archivos.')
                            if (response.status === 422){
                              logout()
                            }
                            return null
                          }
                            return response.json()
                          }).then(response => {                              
                            if (response && response.Upload === 'OK'){               
                              setUploadMsg("Consolidando históricos...")  
                              authFetch("/api/update-historic-consumption?username=" + String(props.username) +
                                "&year="+billingDate.getFullYear()+"&month="+String( billingDate.getMonth() + 1 )
                                +"&cycle="+cycle+"&user_type="+props.userType + "&version="+props.tariffCalcVersion
                                ).then(response => {
                                    if (response.status === 422){
                                        logout()
                                        return null
                                    }
                                    if (response.status !== 200){
                                      setUploadDialog(true)
                                      setIsLoading(false)
                                      setUploadMessage('Error al subir archivos.')
                                      return null
                                    }
                                      return response.json()
                                    }).then(response => {
                                        if (response && response.Upload === 'OK'){                                                
                                          setUploadMessage('Archivos de consumos procesado exitosamente.')   
                                          setUploadMsg("")                                                
                                          setUploadDialog(true) 
                                          setIsLoading(false)                                                                                                                                                      
                                        }
                                    }
                                )  
                              
                            }       
                            else {    
                              setUploadMessage('Error.')                    
                              setUploadDialog(true) 
                              setIsLoading(false)                            
                            }                                      
                        }
                        )
                      }                    
                      else {
                          setUploadDialog(true)
                          setIsLoading(false)
                          setUploadMessage('Error al subir archivos.')
                      }                                
                  })
          }
          else {
          setUploadDialog(true)
          setIsLoading(false)
          setUploadMessage('Error al subir archivos.')
          }
      }) 
                                                    
    
    } 
    else {
      setUploadDialog(true)
      setUploadMessage('No ha seleccionado ningún archivo.')
    }        
  }

  const handleUseTypicalCurve = (cycle) => {
    setTypicalCurveLoading(true)
    setTypicalCurveLoadingMsg("Aplicando curva típica...")
    let opts = {
      filename: selectedClient,
      maintenance_rules: cycleMaintenanceRules[cycle] || []
    }
    authFetch("/api/process-consumption-file?username="+props.username+
                                      "&billing_period="+String( billingDate.getMonth() + 1 )+                                                                                                                                  
                                      "&billing_year="+ billingDate.getFullYear() +                                                                                                                                              
                                      "&user_type="+ props.userType +
                                      "&cycle="+ cycle +
                                      "&autogenerator=NO" +
                                      "&from=typical_consumption" +
                                      "&user_code="+ selectedClient +
                                      "&version="+ props.tariffCalcVersion
                                      
      ,
      {
        method: 'post',                
        body: JSON.stringify(opts)
      }
    ).then(response => {
      if (response.status !== 200){
        setUploadDialog(true)
        setTypicalCurveLoading(false)
        setUploadMessage('Error al subir archivos.')
        if (response.status === 422){
          logout()
        }
        return null
      }
        return response.json()
      }).then(response => {                              
        if (response && response.Upload === 'OK'){               
          setTypicalCurveLoadingMsg("Consolidando históricos...")  
          authFetch("/api/update-historic-consumption?username=" + String(props.username) +
            "&year="+billingDate.getFullYear()+"&month="+String( billingDate.getMonth() + 1 )
            +"&cycle="+cycle+"&user_type="+props.userType + "&version="+props.tariffCalcVersion
            ).then(response => {
                if (response.status === 422){
                    logout()
                    return null
                }
                if (response.status !== 200){
                  setUploadDialog(true)
                  setTypicalCurveLoading(false)
                  setUploadMessage('Error al subir archivos.')
                  return null
                }
                  return response.json()
                }).then(response => {
                    if (response && response.Upload === 'OK'){                                                
                      setTypicalCurveLoadingMsg('Curva típica aplicada correctamente.')
                      setUploadMessage("Consumos actualizados.")
                      setUploadDialog(true) 
                      setTypicalCurveLoading(false)                                                                                                                                                      
                    }
                }
            )  
          
        }       
        else {    
          setUploadMessage('Error.')                    
          setUploadDialog(true) 
          setTypicalCurveLoading(false)                            
        }                                      
    }
    )
  }

  const handleUploadTypicalCurve = (e) => {
    e.preventDefault()
    if (e.target.files.length > 0){                 
      setTypicalCurveUploading(true)                    
      setTypicalCurveUploadMsg("Subiendo archivo...")
      const formData = new FormData()
      let i = 0
      let file = {}
      for (file of e.target.files){
          formData.append('file' + i, file)
          i = i + 1
      }
      let opts = {
          'filename': e.target.files[0].name,      
          'contentType': e.target.files[0].type,              
      }
      authFetch(
          "/api/get-gcs-signed-url?username="+props.username+
                          "&period="+String( billingDate.getMonth() + 1 )+                                                              
                          "&year="+ billingDate.getFullYear() +
                          "&files_from="+ 'typical_consumption',
          {
              method: 'post',                
              //body: formData,
              body: JSON.stringify(opts)
          }
      ).then(r => {
            if (r.status === 422){
              logout()
              return null
            }
            else{
              return r.json()
            }
          })
        .then(response => {
            if (response.url){   
                let gcs_signed_url = response.url
                fetch(
                    gcs_signed_url,               
                    {
                        method: 'put',            
                        body: e.target.files[0],
                        headers: {
                            'Content-Type': e.target.files[0].type
                        }
                    }
                ).then(r => {if (r.status === 200){ return true } else {return false}})
                .then(response => {
                        if (response){
                          setTypicalCurveUploadMsg("Procesando archivo...")
                          //alert('llamado a procesar')
                          authFetch("/api/process-typical-curve-file?username="+props.username+
                                                                    "&user_type="+ props.userType+
                                                                    "&user_code="+ selectedClient
                            ,
                            {
                              method: 'post',                
                              body: JSON.stringify(opts)
                            }
                          ).then(response => {
                              if (response.status !== 200){
                                setUploadDialog(true)
                                setTypicalCurveUploading(false)
                                setUploadMessage('Error al subir archivos.')
                                if (response.status === 422){
                                  logout()
                                }
                                return null
                              }
                              else{
                                setTypicalCurveUploadMsg("Archivo cargado...")
                                setTypicalCurveUploading(false)
                                setUploadMessage('Datos cargados exitosamente.')
                                setUploadDialog(true)
                                authFetch("/api/check-user-has-typical-curve?username=" + String(props.username)
                                  +"&user_code=" + selectedClient).then(response => {
                                    if (response.status === 422){
                                        logout()
                                        return null
                                      }
                                      return response.json()
                                    }).then(response => {
                                        if (response && "has" in response){
                                          setUserWithTypicalCurve(response.has)
                                        }
                                    })
                              }
                                
                              })
                            }
                          })
                        }
      })
    }
  }

  const handleViewTypicalCurve = () => {
    // fetch curve for client
      authFetch("/api/get-user-typical-curve?username=" + String(props.username)
      +"&user_code=" + selectedClient + "&year="+billingDate.getFullYear()+"&month="+String( billingDate.getMonth() + 1 )).then(response => {
          if (response.status === 422){
              logout()
              return null
            }
            return response.json()
          }).then(response => {
            if (response && response.curve){
              setTypicalCurveInfo(response.curve)
              setOpenModal(true);
            }
          })
  };

  const handleDownloadTypicalCurvesZip = () => {
    setDownloadingZipTypicalCurves(true);
    let period = String(billingDate.getMonth() + 1);
    let year = billingDate.getFullYear();
    let monthStr = period.length === 1 ? "0" + period : period;

    authFetch(
      "/api/download-curvas-tipicas-zip?username=" + String(props.username) +
      "&period=" + period +
      "&year=" + year +
      "&version=" + props.tariffCalcVersion
      + "&timestamp=" + new Date().getTime(),
      { responseType: 'blob' }
    ).then(response => {
      if (response.status === 422){
        logout();
        return null;
      }
      if (response.status === 200){
        return response.blob();
      } else {
        setUploadMessage('Error al descargar el archivo de curvas típicas.');
        setUploadDialog(true);
        setDownloadingZipTypicalCurves(false);
        return null;
      }
    }).then(blob => {
      if (blob) {
        setDownloadingZipTypicalCurves(false);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'Curvas_Tipicas_Consumo_' + year + monthStr + '.zip';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      }
    });
  };

  const handleSwitchChange = (event) => {
    setModificationDialog(true)
    setModificationDesignation([event.target.name, event.target.id])
  }

  // A modificar para bd agpe gd 
  const deleteFromDialog = () => {
    setIsLoading(true)      
    authFetch(
      "/api/delete-cycle-consumption?username=" + String(props.username) +
      "&year="+billingDate.getFullYear()+"&month="+String( billingDate.getMonth() + 1 )     
      +"&cycle="+modificationDesignation[0] + "&version="+props.tariffCalcVersion
      ).then(r => {
            if (r.status === 422){
              logout()
              return null
            }
            else{
              return r.json()
            }
          })
      .then(response => {
        if (response && response.Delete === 'OK'){
          setIsLoading(false)
          setModificationDialog(false)
          setUploadMessage('Consumos del ciclo eliminados.')                    
          setUploadDialog(true)
        }
        else {
          alert("Error en el proceso")
          setIsLoading(false)
        }
    })
  }

  useEffect (() => {
      document.title ="Consumos por ciclo"; 
      authFetch("/api/check-billing-cycles?username=" + String(props.username)
      + "&user_type=" + props.userType
    ).then(response => {
        if (response.status === 422){
            logout()
        }
            return response.json()
        }).then(response => {
            if (response && response.cycles){                                                                        
                setCycles(response.cycles)                                                                                
            }
        })
      authFetch("/api/get-cycle-users?username=" + String(props.username)+
        "&year="+billingDate.getFullYear()+"&month="+String( billingDate.getMonth() + 1 )+"&billing=true"
      +"&user_type="+props.userType).then(response => {
        if (response.status === 422){
            logout()
        }
            return response.json()
        }).then(response => {
            if (response && response.cycle_users){   
                let cycleUsers = response.cycle_users               
                setCyclesUsers(response.cycle_users)
                let opts = {
                  users_by_cycle: cycleUsers,                    
                }
                authFetch("/api/check-cycle-consumptions?username=" + String(props.username) +
                "&year="+billingDate.getFullYear()+"&month="+String( billingDate.getMonth() + 1 )
                +"&user_type="+props.userType+"&version="+props.tariffCalcVersion,
                {
                  method: 'post',
                  body: JSON.stringify(opts)
                }
                ).then(response => {
                  if (response.status === 422){
                      logout()
                      return null
                  }
                      return response.json()
                  }).then(response => {
                      if (response && response.cycle_consumption_flags){                  
                        setCycleConsumption(response.cycle_consumption_flags)                                                                                                                                                
                      }
                  }) 
                  authFetch("/api/check-billing-status-by-cycle?username=" + String(props.username) +
                  "&year="+billingDate.getFullYear()+"&month="+String( billingDate.getMonth() + 1 )+
                  "&user_type="+props.userType
                  + "&version=" + props.tariffCalcVersion,
                  {
                      method: 'post',
                      body: JSON.stringify(opts)
                  }
                  ).then(response => {
                      if (response.status === 422){
                          logout()
                          return null
                      }
                          return response.json()
                      }).then(response => {
                          if (response && response.billing_status){                                            
                              setBillingStatus(response.billing_status)                                                                                                                                                
                          }
                      }
                  )                                            
            }
        }) 
      
  }, [isLoading, props.billingDate, typicalCurveLoading])

  useEffect (() => {
    // Check if user has typical curve
    if (selectedClient === ''){
      return
    }
    authFetch("/api/check-user-has-typical-curve?username=" + String(props.username)
      +"&user_code=" + selectedClient).then(response => {
        if (response.status === 422){
            logout()
            return null
          }
          return response.json()
        }).then(response => {
            if (response && "has" in response){
              setUserWithTypicalCurve(response.has)
            }
        })
  }, [selectedClient])

  const modificationConfirm = () => (
    <Dialog
      open={modificationDialog}
      onClose={handleModificationDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"¿Desea elimina la información seleccionada?"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Si desea eliminar la información relacionada al ciclo {modificationDesignation[0]}, haga click en ACEPTAR.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleModificationDialogClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={deleteFromDialog} color="primary" autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )
  
  const uploadConfirm = () => (
    <Dialog
      open={uploadDialog}
      onClose={handleUploadDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Información"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {uploadMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleUploadDialogClose} color="primary" autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )

  const maintenanceModal = () => (
    <Dialog 
      open={maintenanceDialogOpen} 
      onClose={() => setMaintenanceDialogOpen(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Configurar Modo Mantenimiento (Consumo 0)</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Seleccione el usuario y el rango de fecha/hora donde la estimación calculada por curva típica debe reemplazarse por ceros.
        </DialogContentText>
        <Grid container spacing={2} style={{ marginTop: 8 }}>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Cliente / Código"
              variant="outlined"
              value={maintenanceConfig.clientCode}
              onChange={(e) => setMaintenanceConfig({ ...maintenanceConfig, clientCode: e.target.value })}
            >
              {(cyclesUsers["users_" + currentCycleForMaintenance] || []).map((client, idx) => (
                <MenuItem key={idx} value={client}>{client}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Inicio Mantenimiento"
              type="datetime-local"
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={maintenanceConfig.startDateTime}
              onChange={(e) => setMaintenanceConfig({ ...maintenanceConfig, startDateTime: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Fin Mantenimiento"
              type="datetime-local"
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={maintenanceConfig.endDateTime}
              onChange={(e) => setMaintenanceConfig({ ...maintenanceConfig, endDateTime: e.target.value })}
            />
          </Grid>

          {cycleMaintenanceRules[currentCycleForMaintenance]?.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary">Reglas configuradas para el ciclo {currentCycleForMaintenance}:</Typography>
              {cycleMaintenanceRules[currentCycleForMaintenance].map((rule, idx) => (
                <Box key={idx} display="flex" justifyContent="space-between" alignItems="center" mt={1} p={1} style={{ border: `1px solid ${theme.palette.divider}`, borderRadius: 4 }}>
                  <Typography variant="body2">
                    <strong>{rule.clientCode}:</strong> {rule.startDateTime.replace('T', ' ')} hrs ➔ {rule.endDateTime.replace('T', ' ')} hrs
                  </Typography>
                  <IconButton size="small" onClick={() => {
                    setCycleMaintenanceRules(prev => ({
                      ...prev,
                      [currentCycleForMaintenance]: prev[currentCycleForMaintenance].filter((_, i) => i !== idx)
                    }));
                  }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setMaintenanceDialogOpen(false)} color="secondary">
          Cerrar
        </Button>
        <Button 
          color="primary" 
          variant="contained"
          disabled={!maintenanceConfig.clientCode || !maintenanceConfig.startDateTime || !maintenanceConfig.endDateTime}
          onClick={() => {
            setCycleMaintenanceRules(prev => ({
              ...prev,
              [currentCycleForMaintenance]: [
                ...(prev[currentCycleForMaintenance] || []),
                maintenanceConfig
              ]
            }));
            setMaintenanceConfig({ clientCode: '', startDateTime: '', endDateTime: '' });
          }}
        >
          Agregar Regla
        </Button>
      </DialogActions>
    </Dialog>
  )

  const uploadForm = (filename, extensions, idx, quantity, cycle, autogenerator) => (
    <form action={"#"}>
        <label htmlFor={filename}>
        <input
          hidden
          id={filename}
          name={filename}
          type="file"   
          accept={extensions} 
          onClick={(e) => {setClickIndex(idx); e.target.value = null;}}   
          onChange={(e) => {handleUploadFile(e, cycle, autogenerator); }}            
          multiple={quantity === "1" ? false : true}  
        />
        {
          isLoading && idx === clickIndex?
          <Grid container spacing={0} justify="center">
            <CircularProgress></CircularProgress>
            <Grid item xs={12}></Grid>
            <Typography variant="subtitle2" color="primary">{uploadMsg}</Typography>
          </Grid>
          :
          <Fab
            color="primary"
            size="small"
            component="span"
            aria-label="add"
            variant="extended"                        
            classes={{root: classes.uploadButton}}                          
          >
            <AddIcon /> { quantity === "1" ? 'Subir archivo' : 'Subir archivos' }
          </Fab>
        }
                
      </label>
    </form>     
  )

  const uploadCurveForm = (filename) => (
    <form action={"#"}>
        <label htmlFor={filename}>
        <input
          hidden
          id={filename}
          name={filename}
          type="file"   
          accept={".xlsx, .csv"}
          onChange={(e) => {handleUploadTypicalCurve(e); }}            
        />
        {
          typicalCurveUploading?
          <Grid container spacing={0} justify="center">
            <CircularProgress></CircularProgress>
            <Grid item xs={12}></Grid>
            <Typography variant="subtitle2" color="primary">{typicalCurveUploadMsg}</Typography>
          </Grid>
          :
          <Fab
            color="primary"
            size="small"
            component="span"
            aria-label="add"
            variant="extended"                        
            classes={{root: classes.uploadButton}}
            style={{width: "100%"}}
            disabled={selectedClient === ''}
          >
            <AddIcon style={{marginRight: "0.5rem"}}/> Cargar Curva
          </Fab>
        }
                
      </label>
    </form>     
  )


  const typicalCurveTable = (cycles) => (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell align="center" style={{width: "15%"}}>Ciclo</StyledTableCell>
            <StyledTableCell align="center" style={{width: "20%"}}>Código cliente</StyledTableCell>
            <StyledTableCell align="center">Acción</StyledTableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          {
            cycles.map((cycle, idx) => (         
            <StyledTableRow key={idx}>
              <StyledTableCell align="center">{cycle.code}</StyledTableCell>
              <StyledTableCell align="center">
                <TextField
                  select
                  fullWidth
                  value={selectedClient}
                  onChange={(e) => setSelectedClient(e.target.value)}
                >
                  {
                    cyclesUsers["users_" + cycle.code] && cyclesUsers["users_" + cycle.code].length > 0  ?
                    
                    cyclesUsers["users_" + cycle.code].map((client, cIdx) => (
                      <MenuItem key={cIdx} value={client}>
                        {client}
                      </MenuItem>
                    ))
                    :
                    []
                  }
                </TextField>
              </StyledTableCell>

              <StyledTableCell align="center">
                <Grid container justify="space-evenly" alignItems="center">
                  <Grid item xs={2}>
                  {uploadCurveForm("typ"+selectedClient)}
                  </Grid>
                  <Grid item xs={2}>
                  <Fab
                    variant="extended"
                    color="primary"
                    onClick={handleViewTypicalCurve}
                    disabled={!userWithTypicalCurve}
                    classes={{root: classes.uploadButton}}
                    style={{width: "100%"}}
                    size='small'
                  >
                    <TimelineIcon style={{marginRight: "0.5rem"}}/> Visualizar
                  </Fab>
                  </Grid>
                  <Grid item xs={3}>
                  {
                    typicalCurveLoading ?
                     <Grid container spacing={0} justify="center">
                      <CircularProgress></CircularProgress>
                      <Grid item xs={12}></Grid>
                      <Typography variant="subtitle2" color="primary">{typicalCurveLoadingMsg}</Typography>
                    </Grid>
                    :
                    <Fab
                    variant="extended"
                    color="primary"
                    onClick={(e) => {handleUseTypicalCurve(cycle.code);}}
                    disabled={!userWithTypicalCurve || cycleConsumption[cycle.code]}
                    classes={{root: classes.uploadButton}}
                    size='small'
                    style={{width: "100%"}}
                    >
                      <SaveIcon style={{marginRight: "0.5rem"}}/> Usar en este periodo
                    </Fab>
                  }
                  </Grid>
                  <Grid item xs={3}>
                  {
                    downloadingZipTypicalCurves ?
                     <Grid container spacing={0} justify="center">
                      <CircularProgress size={24}></CircularProgress>
                    </Grid>
                    :
                    <Fab
                      variant="extended"
                      color="primary"
                      onClick={handleDownloadTypicalCurvesZip}
                      classes={{root: classes.uploadButton}}
                      size='small'
                      style={{width: "100%"}}
                    >
                      <GetAppIcon style={{marginRight: "0.5rem"}}/> Exportar Curvas (ZIP)
                    </Fab>
                  }
                  </Grid>
                </Grid>
              </StyledTableCell>
            </StyledTableRow>
          ))
        }
          {/* {isLoading && (
            <StyledTableRow>
              <StyledTableCell colSpan={2} align="center">
                <CircularProgress size={24} />
                <Typography variant="body2">{uploadMsg}</Typography>
              </StyledTableCell>
            </StyledTableRow>
          )} */}
        </TableBody>
      </Table>
    </TableContainer>
  )

  const firstStepContent = () => (
    <TableContainer component={Paper}>
      {modificationConfirm()}
      {uploadConfirm()}
      <Table className={classes.table} stickyHeader>
          <TableHead>
              <TableRow>
                  <StyledTableCell align="center" style={{width: "15%"}}>Ciclo</StyledTableCell>
                  <StyledTableCell align="center" style={{width: "15%"}}>No. usuarios</StyledTableCell>                    
                  <StyledTableCell align="center" style={{width: "25%"}}>Mercado</StyledTableCell>
                  <StyledTableCell align="center" style={{width: "15%"}}>Ingreso</StyledTableCell>
                  <StyledTableCell align="center" style={{width: "15%"}}>Modificar</StyledTableCell>
              </TableRow>
          </TableHead>
          <TableBody>
              { cycles.length > 0 ? 
                
                cycles.map((cycle, idx) => (
                  <Fragment key={idx}>
                    {
                      cyclesUsers[cycle.code] > 0 ?
                      <StyledTableRow key={idx}>
                        
                        <StyledTableCell component="th" scope="row" align="center">{cycle.code}</StyledTableCell>
                        <StyledTableCell align="center">{cyclesUsers[cycle.code]}</StyledTableCell>
                        <StyledTableCell align="center">{cycle.market_type}</StyledTableCell>
                        <StyledTableCell align="center">
                          {
                              cycleConsumption[cycle.code] ? 
                              <Grid container justify="space-evenly" alignItems="center">
                                <Grid item>
                                  <CheckCircleOutlineIcon color="action"/>         
                                </Grid> 
                                <Grid item>
                                  Listo
                                </Grid>                                                                                                                                                                          
                              </Grid>                                        
                              :
                              <Grid container justify="space-evenly" alignItems="center">
                                <Grid item>
                                  <HourglassEmptyIcon color="error"/>         
                                </Grid> 
                                <Grid item>
                                  Pendiente
                                </Grid>                                                                                                                                                                          
                              </Grid>  
                          }
                        </StyledTableCell>                                                
                        <StyledTableCell align="center">
                          <Switch 
                            disabled={!cycleConsumption[cycle.code] || billingStatus[cycle.code] || cycleConsumption['ap_'+cycle.code]} 
                            checked={modificationDialog && modificationDesignation[0] === cycle.code} 
                            key={idx}  id={String(idx)} color="primary" name={cycle.code} onChange={handleSwitchChange}/>
                        </StyledTableCell>
                      </StyledTableRow>
                      :
                      null
                    }
                    
                    </Fragment>
                  ))
                :
                null
              }                
          </TableBody>
      </Table>
    </TableContainer>
  )

  const secondStepContent = () => (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" align="center">Cargar consumos desde archivo:</Typography>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            {uploadConfirm()}
            {maintenanceModal()}
            <Table className={classes.table} stickyHeader>
                <TableHead>
                    <TableRow>
                    <StyledTableCell align="center" style={{width: "10%"}}>Ciclo</StyledTableCell>
                        <StyledTableCell align="center" style={{width: "10%"}}>No. usuarios</StyledTableCell>                    
                        <StyledTableCell align="center" style={{width: "15%"}}>Mercado</StyledTableCell>
                        <StyledTableCellSecondStep align="center">Extensión</StyledTableCellSecondStep>
                        <StyledTableCellSecondStep align="center">Cantidad</StyledTableCellSecondStep>
                        <StyledTableCellSecondStep align="center">Tipo consumo</StyledTableCellSecondStep>
                        <StyledTableCellSecondStep align="center">Mantenimiento</StyledTableCellSecondStep>
                        <StyledTableCellSecondStep align="center">Ingreso</StyledTableCellSecondStep>
                      
                    </TableRow>
                </TableHead>
                <TableBody>
                    { cycles.length > 0 ? 
                        cycles.map((cycle, idx) => (
                            cycleConsumption[cycle.code] ? 
                            null
                            :
                              cyclesUsers[cycle.code] > 0 ?
                              <StyledTableRow key={idx}>
                                  <StyledTableCellSecondStep component="th" scope="row" align="center">
                                      {cycle.code}
                                  </StyledTableCellSecondStep>
                                  <StyledTableCellSecondStep align="center"> { cyclesUsers[cycle.code] }</StyledTableCellSecondStep>                    
                                  <StyledTableCellSecondStep align="center">{ cycle.market_type }</StyledTableCellSecondStep> 
                                  <StyledTableCellSecondStep align="center">{ '.xlsx, .csv' }</StyledTableCellSecondStep> 
                                  <StyledTableCellSecondStep align="center">{ 1 }</StyledTableCellSecondStep> 
                                  <StyledTableCellSecondStep align="center">
                                      <Switch disabled={true} checked={true} color="primary"/>
                                  </StyledTableCellSecondStep>
                                  <StyledTableCellSecondStep align="center">
                                      <Button
                                        size="small"
                                        variant="outlined"
                                        color={cycleMaintenanceRules[cycle.code]?.length > 0 ? "secondary" : "default"}
                                        startIcon={<BuildIcon />}
                                        onClick={() => {
                                          setCurrentCycleForMaintenance(cycle.code);
                                          setMaintenanceDialogOpen(true);
                                        }}
                                      >
                                        {cycleMaintenanceRules[cycle.code]?.length > 0 
                                          ? `${cycleMaintenanceRules[cycle.code].length} Regla(s)` 
                                          : "Horas en 0"}
                                      </Button>
                                  </StyledTableCellSecondStep>
                                  <StyledTableCellSecondStep align="center">
                                      {                                         
                                          uploadForm(cycle.code, '.xlsx, .csv', idx, '1', cycle.code, "NO")
                                      }                                
                                  </StyledTableCellSecondStep>                                                             
                              </StyledTableRow>
                              :
                              null
                            ))
                            
                        :
                        null
                    }
                </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      <Grid item xs={12} style={{marginTop: 30}}>
          <Typography variant="subtitle2" align="center">Curva Típica/Frontera en Falla:</Typography>
        </Grid>
      <Grid item xs={12}>
        {
          typicalCurveTable(cycles)
        }
      </Grid>
      </Grid>
  )

  const thirdStepContent = () => (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
      <TableHead>
            <TableRow>
                <StyledTableCellCollapse/>
                <StyledTableCellCollapse align="left" style={{width: "25%"}}>Ciclo</StyledTableCellCollapse>
                <StyledTableCellCollapse align="left">No. usuarios</StyledTableCellCollapse>
                <StyledTableCellCollapse align="left">Periodo de consumo</StyledTableCellCollapse>                
            </TableRow>
        </TableHead>
        <TableBody>
          {cycles.length > 0 ?
              cycles.map((cycle, idx) => (   
              cyclesUsers[cycle.code] > 0 ?             
              <ThirdStepRow key={idx} row={cycle} billingDate={billingDate} cyclesUsers={cyclesUsers} cycleConsumption={cycleConsumption}/>
              :
              null
              ))
            :
            null
          }
        </TableBody>
      </Table>
    </TableContainer>
  )

  function getStepContent(step) {
      switch (step) {
        case 0:
          return (
            firstStepContent()
          )
        case 1:
          return (
            secondStepContent()
          )          
        case 2:
          return (
            thirdStepContent()
          );
        default:
          return 'Unknown step';
      }
  }

  const trendData = [{
      x: typicalCurveInfo.eje_x_dias,
      y: typicalCurveInfo.eje_y_totales_diarios,
      type: 'scatter',
      mode: 'lines+markers',
      name: 'Consumo Diario',
      line: { color: theme.palette.primary.main, shape: 'spline' },
      marker: { size: 6 },
      hovertemplate: '<b>%{x|%A, %b %d}</b><br>' +
                     'Consumo: %{y:.2f} kWh<extra></extra>'
  }];

  const scatterLayout = (suffix) => ({
      xaxis: {
          type: 'date',
          tickformat: '%d %b', // Muestra "01 Mar"
          tickfont: { size: 10, family: 'inherit' },
          fixedrange: true,
          showgrid: true,
          gridcolor: 'rgba(0,0,0,0.05)'
      },
      yaxis: {
          zerolinecolor: theme.palette.primary.main,
          zerolinewidth: 2,
          showgrid: true,
          gridcolor: 'rgba(0,0,0,0.05)',
          ticksuffix: suffix,
          tickfont: { size: 11 },
          fixedrange: true 
      },
      hovermode: "closest",
      font: { family: 'inherit', size: 12 },
      margin: { b: 40, t: 20, l: 85, r: 20, pad: 5 },
      paper_bgcolor: theme.palette.background.paper,
      plot_bgcolor: theme.palette.background.paper,
      width: 600, // Ajustable o usar useMediaQuery para responsividad
      height: 400
  });
    

    return (
        <div className={classes.root}>
          {
             props.market !== '' ?
             true ?                                    
              <Grid container spacing={3} justify="center">
                  <Zoom in timeout={800}>                                                 
                    <Grid item xs={12}>                        
                        <Paper elevation={2}>
                            <Stepper nonLinear activeStep={activeStep} classes={{root: classes.stepper}}>
                                {steps.map((label, index) => {
                                return (
                                    <Step key={index} >
                                        <StepButton onClick={handleStep(index)}>
                                            <StepLabel classes={{label: classes.stepText, active: classes.stepTextActive}}>{label}</StepLabel>
                                        </StepButton>
                                    </Step>
                                );
                                })}
                            </Stepper>                        
                        </Paper>                    
                    </Grid>
                  </Zoom>
                  <Zoom in timeout={800}>
                    <Grid item xs={3}>
                        <div>
                            <IconButton disabled={activeStep === 0} onClick={handleBack} className={classes.button} color={"primary"}>
                                <ArrowBackIosIcon/>
                            </IconButton>    
                            <IconButton disabled={activeStep === steps.length-1} onClick={handleNext} className={classes.button} color={"primary"}>
                                <ArrowForwardIosIcon/>
                            </IconButton>
                        </div>
                    </Grid>
                  </Zoom>
                  <Zoom in style={{transitionDelay: '600ms'}} timeout={800}>
                    <Grid item xs={12}>                                
                            {getStepContent(activeStep)}            
                    </Grid>
                  </Zoom>
                  <Dialog 
                      open={openModal} 
                      onClose={() => setOpenModal(false)}
                      maxWidth="md"
                      fullWidth
                  >
                    <DialogTitle>
                        <Grid container justify="space-between" alignItems="center">
                            <Typography variant="h6" color="primary">Curva Típica</Typography>
                            <IconButton onClick={() => setOpenModal(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Paper className={classes.contentPaperNoBottomPadding} elevation={0} variant="outlined">
                            <Grid container style={{ padding: 10 }} spacing={2} justify="center">
                                <Grid item xs={12}>
                                    <Typography variant='subtitle2' align="center" color='primary'>
                                        Consumo totalizado por día - Mes de facturación
                                    </Typography>
                                </Grid>
                                
                                {/* Mostrar el Total del Mes */}
                                <Grid item>
                                    <div style={{ textAlign: 'center', padding: '10px', border: `1px solid ${theme.palette.divider}`, borderRadius: 8 }}>
                                        <Typography variant="caption" color="textSecondary" display="block">TOTAL MES</Typography>
                                        <Typography variant="h4" color="primary" display="inline">
                                            {typicalCurveInfo.suma_total_mes.toLocaleString()}
                                        </Typography>
                                        <Typography variant="subtitle2" color="primary" display="inline">{" kWh"}</Typography>
                                    </div>
                                </Grid>

                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Plot
                                        data={trendData}
                                        layout={scatterLayout(' kWh')}
                                        config={{ 
                                            displayModeBar: false, 
                                            responsive: true,
                                            locales : {'es-ES': localeDictionary},
                                            locale: 'es-ES'
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </DialogContent>
                  </Dialog>
              </Grid>            
              :
              null
            :
            null
          }            
        </div>
    );
}